import Vue from 'vue';
/* eslint-disable import/extensions */
import AccentComponent from '@/components/AccentComponent';
import BranchesMapSliderComponent from '@/components/BranchesMapSliderComponent';
import ContactLocationComponent from '@/components/ContactLocationComponent';
import DefaultZizAccordion from '@/components/DefaultZizAccordion';
import HeaderLineComponent from '@/components/HeaderLineComponent';
import HeaderToggleButtonComponent from '@/components/HeaderToggleButtonComponent';
import Header from '@/components/common/Header';
import Icons from '@/components/Icons';
import PriceTableAccordion from '@/components/PriceTableAccordion';
import VideoWrapper from '@/components/widgets/VideoWrapper';
import Accordion from '@/components/widgets/Accordion';
import ListItem from '@/components/widgets/Accordion/item';
import FaqAccordion from '@/components/widgets/FAQAccordion';
import DonationValue from '@/components/widgets/DonationValue';
import ProductsBanner from '@/pages/Products/components/Banner';
import PhotoConsultComponent from '@/pages/PhotoConsult/index.vue';
import ArticlesList from '@/pages/Articles/components/ArticlesList';
import TripettoLoading from '@/components/ui/TripettoLoading';

// Static imports (main bundle)
[
  AccentComponent,
  BranchesMapSliderComponent,
  ContactLocationComponent,
  DefaultZizAccordion,
  Header,
  Icons,
  PriceTableAccordion,
  VideoWrapper,
  Accordion,
  ListItem,
  ProductsBanner,
  FaqAccordion,
  DonationValue,
  PhotoConsultComponent,
  ArticlesList,
].forEach((component) => Vue.component(component.name, component));

Vue.component('HeaderLineComponent', HeaderLineComponent);
Vue.component(HeaderToggleButtonComponent.name, HeaderToggleButtonComponent);

// The Tripetto chunks (runner + form definition) are heavy, so keep a spinner
// on screen while they download instead of an empty page area.
const withLoading = (loader) => () => ({
  component: loader(),
  loading: TripettoLoading,
  delay: 0,
});

// Dynamic imports
Object.entries({
  TripettoLanguageSelector: () => import('@/components/TripettoLanguageSelector.vue'),
  TripettoFormComponent: withLoading(() => import('@/components/TripettoFormComponent')),
  IntakeTripettoFormComponent: () => import('@/components/IntakeTripettoFormComponent'),
  FollowUpTripettoFormComponent: () => import('@/components/FollowUpTripettoFormComponent'),
  CheckoutPageComponent: () => import('@/components/CheckoutPageComponent'),
  CheckoutStatusNew: () => import('@/pages/CheckoutStatusNew'),
  IntakeSuccessScreen: () => import('@/pages/CheckoutStatusNew/IntakeSuccessScreen.vue'),
  ResultProductsComponent: () => import('@/components/ResultProductsComponent'),
}).forEach(([name, component]) => Vue.component(name, component));
